import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { services } from "../mock";
import { Button } from "./ui/button";

const ServicesSection = ({ full = false }) => {
  const list = full ? services : services;
  return (
    <section className="section bg-white">
      <div className="mx-auto max-w-7xl px-4">
        <div className="text-center max-w-2xl mx-auto">
          <span className="text-[#2E9E6A] font-semibold uppercase tracking-wide text-sm">Our Services</span>
          <h2 className="font-display font-bold text-3xl md:text-4xl text-[#0E2A33] mt-2">
            Care designed around your loved one
          </h2>
          <p className="text-slate-600 mt-4">
            From daily personal care and homemaker support to companionship, our vetted caregivers deliver dependable support in the comfort of home.
          </p>
        </div>

        <div className="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {list.map((s) => {
            const Icon = s.icon;
            return (
              <div key={s.id} className="card-hover bg-white rounded-2xl border border-slate-100 shadow-sm overflow-hidden">
                <div className="h-44 overflow-hidden">
                  <img src={s.image} alt={s.title} loading="lazy" decoding="async" className="h-full w-full object-cover transition-transform duration-500 hover:scale-105" />
                </div>
                <div className="p-6">
                  <div className="brand-gradient h-11 w-11 rounded-xl grid place-items-center text-white -mt-10 relative shadow-lg">
                    <Icon className="h-6 w-6" />
                  </div>
                  <h3 className="font-display font-bold text-lg text-[#0E2A33] mt-4">{s.title}</h3>
                  <p className="text-slate-600 text-sm mt-2">{s.short}</p>
                  {full && (
                    <ul className="mt-4 space-y-2">
                      {s.details.map((d) => (
                        <li key={d} className="text-sm text-slate-600 flex items-start gap-2">
                          <span className="mt-1.5 h-1.5 w-1.5 rounded-full bg-[#2E9E6A] shrink-0" /> {d}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            );
          })}
        </div>

        {!full && (
          <div className="text-center mt-10">
            <Link to="/services">
              <Button className="bg-[#0E5A72] hover:bg-[#0A4557] text-white rounded-full h-12 px-7">
                Explore all services <ArrowRight className="ml-2 h-4 w-4" />
              </Button>
            </Link>
          </div>
        )}
      </div>
    </section>
  );
};

export default ServicesSection;
